(() => {
  const normalise = (value) =>
    value
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-');

  function getSelectedColour(productInfo) {
    const picker = productInfo.querySelector('variant-selects');
    if (!picker) return null;

    const checkedInputs = picker.querySelectorAll(
      'input:checked[data-option-name]'
    );

    for (const input of checkedInputs) {
      const optionName = input.dataset.optionName?.toLowerCase();

      if (optionName === 'color' || optionName === 'colour') {
        return normalise(input.value);
      }
    }

    const selects = picker.querySelectorAll('select');

    for (const select of selects) {
      const name = select.name?.toLowerCase() || '';

      if (name.includes('color') || name.includes('colour')) {
        return normalise(select.value);
      }
    }

    return null;
  }

  function filterGallery(productInfo) {
    const colour = getSelectedColour(productInfo);
    if (!colour) return;

    const marker = `lap-colour-${colour}`;
    const gallery = productInfo.querySelector('media-gallery');

    if (!gallery) return;

    const mediaItems = [
      ...gallery.querySelectorAll('.product__media-item')
    ];

    let firstMatchingMedia = null;

    mediaItems.forEach((item) => {
      const image = item.querySelector('img[alt]');
      if (!image) return;

      const alt = image.alt.toLowerCase();

      if (alt.includes('lap-colour-')) {
        const matchesColour = alt.includes(marker);

        item.style.display = matchesColour ? '' : 'none';

        if (matchesColour && !firstMatchingMedia) {
          firstMatchingMedia = item;
        }
      }
    });

    const thumbnails = [
      ...gallery.querySelectorAll('.thumbnail-list__item')
    ];

    thumbnails.forEach((thumbnail) => {
      const image = thumbnail.querySelector('img[alt]');
      if (!image) return;

      const alt = image.alt.toLowerCase();

      if (alt.includes('lap-colour-')) {
        thumbnail.style.display = alt.includes(marker) ? '' : 'none';
      }
    });

    /*
     * Dawn desktop thumbnail layouts only display the
     * product image carrying the "is-active" class.
     *
     * If the currently active image belongs to the old
     * colour, activate the first image of the new colour.
     */
    const activeMedia = gallery.querySelector(
      '.product__media-item.is-active'
    );

    const activeImage = activeMedia?.querySelector('img[alt]');

    const activeMatchesColour =
      activeMedia &&
      activeMedia.style.display !== 'none' &&
      activeImage &&
      activeImage.alt.toLowerCase().includes(marker);

    if (!activeMatchesColour && firstMatchingMedia) {
      const mediaId = firstMatchingMedia.dataset.mediaId;

      if (
        mediaId &&
        typeof gallery.setActiveMedia === 'function'
      ) {
        gallery.setActiveMedia(mediaId, false);
      } else {
        mediaItems.forEach((item) =>
          item.classList.remove('is-active')
        );

        firstMatchingMedia.classList.add('is-active');
      }
    }

    /*
     * Recalculate Dawn's thumbnail carousel after
     * hiding/showing colour-specific thumbnails.
     */
    if (
      gallery.elements?.thumbnails &&
      typeof gallery.elements.thumbnails.resetPages === 'function'
    ) {
      gallery.elements.thumbnails.resetPages();
    }
  }

  function runFilter() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      filterGallery(productInfo);
    });
  }

  document.addEventListener('DOMContentLoaded', runFilter);

  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;

    setTimeout(runFilter, 50);
    setTimeout(runFilter, 300);
  });

  const observer = new MutationObserver(() => {
    runFilter();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();